import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export default function WherebyRoomView({ style }) {
  return (
    <View style={[styles.container, style]}>
      <Text style={styles.text}>Video calls are not available on web</Text>
    </View>
  );
}

export function useRoomConnection(_roomUrl, _options) {
  return {
    state: {
      connectionStatus: 'disconnected',
      remoteParticipants: [],
      localParticipant: null,
      screenshares: [],
    },
    actions: {
      joinRoom: () => {},
      leaveRoom: () => {},
      toggleCamera: () => {},
      toggleMicrophone: () => {},
      setDisplayName: () => {},
    },
  };
}

export function useLocalMedia() {
  return {
    state: { currentCameraDeviceId: null, currentMicrophoneDeviceId: null, localStream: null },
    actions: { toggleCamera: () => {}, toggleMicrophone: () => {} },
  };
}

const styles = StyleSheet.create({
  container: { flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#000' },
  text: { color: '#fff', fontSize: 16 },
});
